import { render, staticRenderFns } from "./Customers.html?vue&type=template&id=d52a4b52&scoped=true&external"
import script from "./Customers.js?vue&type=script&lang=js&external"
export * from "./Customers.js?vue&type=script&lang=js&external"
import style0 from "./Customers.scss?vue&type=style&index=0&id=d52a4b52&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52a4b52",
  null
  
)

export default component.exports